/*
export const someAction = (state) => {}
 */
import { api } from 'src/plugins/axios'
import { notify } from 'src/plugins/notify'
import { createQueryString } from 'src/utils'

export default {
  addNew,
  add,
  select,
  fetch,
  fetchAll,
  fetchCourseClasses,
  fetchCourses,
  viewCourseClass,
  fetchAutoComplete,
  fetchCertificates,
  fetchManagers,
  fetchAffiliates,
  create,
  update,
  remove,
  createCourseManager,
  createCourseAffiliate,
  removeCourseManagers,
  removeCourseAffiliates
}

async function addNew ({ commit, state }) {
  commit('clearCourseForm')
  commit('openDetails', { mode: 'add' }, { root: true })
}

async function add ({ commit, dispatch, state }) {
  const response = await dispatch('create')
  if (response.success) commit('clearCourseForm')
  return response
}

async function select ({ commit, state }, payload) {
  commit('clearCourseForm')
  commit('setCourseForm', { selectedCourse: payload })
  commit('openDetails', { module, mode: 'edit' }, { root: true })
}

async function fetch ({ commit, state }, { 
  pagination = { descending: false,
    page: 1,
    rowsNumber: 0,
    rowsPerPage: 10,
    sortBy: null
  }, filter = '', columns, exportOptions }) {
  commit('isLoading')
  try {
    const query = createQueryString({ pagination, filter, columns, exportOptions })
    const { data: response } = await api.get('/course/fetch' + query)
    commit('doneLoading')
    const { success, payload } = response
    if (!success) throw response
    if (!exportOptions) commit('setList', { courses: payload.courses })

    return response
  } catch (response) {
    commit('doneLoading')
    return response
  }
}

async function fetchCourses ({ rootState }){
  let { data } = await api.get('course/fetchCoursesDropdown')
  try{
    let { success, payload } = data
    rootState.students.courses = payload
    if(!success){
      throw "Error Loading Courses for Students.vue"
    }
  }
  catch(err){
    return console.log(err)
  }
}

async function fetchAll ({ commit, state }) {
  commit('isLoading')
  try {
    const { data: response } = await api.get('/course/fetchAll')
    const { success, payload } = response
    if (!success) throw response
    commit('setList', { courses: payload })
    return response
  } catch (response) {
    commit('doneLoading')

    return response
  }
}

async function fetchCourseClasses ({ commit, state }, { pagination, filter, columns }) {
  commit('isLoading')  

  try {
    const customFilter = [{"field": "COURSE_ID", "filter": state.courseForm.COURSE_ID}]
    let query = createQueryString({ pagination, filter, columns, customFilter })
    const { data: response } = await api.get('/course/fetchCourseClasses' + query)
    const { success, payload } = response
    commit('doneLoading')
    commit('setCourseClassList', { classes: payload.rows })
    return response
  } catch (response) {
    notify.respond(response)
  }
}

async function viewCourseClass ({ commit, dispatch, state }, selectedClass) {
  let id = selectedClass.CLASS_ID
  let mode = "edit"
  
  commit('classes/updateModalMode', mode, { root: true })
  commit('classes/updateModalLoading', true, { root: true })

  await api.get('/calendar/' + id)
  .then(result => {
      console.log(result)
      commit('classes/updateSessionInformation', result.data.payload, { root: true })  
      commit('classes/updateSelectedSession', id, { root: true })
      commit('classes/updateModalMode', mode, { root: true })                
      commit('classes/updateModalLoading', false, { root: true })
      commit('classes/updateAddEditClassOpenState', true, { root: true })
  })
}

async function fetchAutoComplete ({ commit, dispatch, state }, { s }) {
  try {
    const { data: response } = await api.post('/course/autocomplete', { s })
    const { success, payload } = response
    if (!success) throw response
    commit('setAutoCompleteList', { courses: payload })
  } catch (response) {
    return response
  }
}

async function fetchCertificates ({ commit, dispatch, state }, { s }) {
  try {
    const courseId = state.courseForm.COURSE_ID
    const { data: response } = await api.get('/course/certificate', { 
      params: {
        courseId,
        s 
      }
    })
    const { success, payload } = response
    if (!success) throw response
    commit('setCertificates', { certificates: payload })
    return response
  } catch (response) {
    notify.respond(response)
    return response
  }
}

async function fetchManagers ({ commit, dispatch, state }, { pagination, filter, columns }) {
  commit('clearSelectedManagers')
  try {
    let query = createQueryString({ pagination, filter, columns })
    const { data: response } = await api.get('/course/manager' + query, {
      params: {
        COURSE_ID: state.courseForm.COURSE_ID
      }
    })
    const { success, payload } = response
    if (!success) throw response
    commit('setManagers', payload)
    commit('updateCourseManagerPagination', { field: 'rowsNumber', value: payload.count })
    return response
  } catch (response) {
    notify.respond(response)
    return response
  }
}

async function fetchAffiliates ({ commit, dispatch, state }, { pagination, filter, columns }) {
  commit('clearSelectedAffiliates')
  try {
    let query = createQueryString({ pagination, filter, columns })
    const { data: response } = await api.get('/course/affiliate' + query, {
      params: {
        COURSE_ID: state.courseForm.COURSE_ID
      }
    })
    const { success, payload } = response
    if (!success) throw response

    commit('setAffiliates', payload)
    commit('updateCourseAffiliatePagination', { field: 'rowsNumber', value: payload.count })

    return response
  } catch (response) {
    notify.respond(response)
    return response
  }
}

async function create ({ commit, dispatch, state }) {
  const { courseForm, notes } = state
  const form = {
    ...courseForm,
    notes
  }
  
  try {
    const { data: response } = await api.post('/course/create', { form })
    const { success, payload } = response
    if (!success) throw response

    commit('updateCourseForm', { field: 'COURSE_ID', value: payload.COURSE_ID })
    dispatch('fetch', {})
    commit('openDetails', { module, mode: 'edit' }, { root: true })
    notify.respond(response)
    return response
  } catch (response) {
    notify.respond(response)
    return response
  }
}

async function update ({ commit, dispatch, state }) {
  const { courseForm, notes } = state
  const form = {
    ...courseForm,
    notes
  }
  try {
    const { data: response } = await api.post('/course/update', { form })
    const { success } = response
    if (!success) throw response
    
    dispatch('fetch', {})
    // commit('closeDetails', {}, { root: true })
    notify.respond(response)
    return response
  } catch (response) {
    notify.respond(response)
  }
}

async function remove ({ commit, dispatch, state }) {
  const { courseForm } = state
  const { COURSE_ID } = courseForm
  try {
    const { data: response } = await api.post('/course/remove', { COURSE_ID })
    const { success } = response

    if (!success) throw response

    dispatch('fetch', {})
    commit('closeDetails', {}, { root: true })
    notify.respond(response)
    return response
  } catch (response) {
    notify.respond(response)
  }
}

async function createCourseManager ({ commit, dispatch, state }, { MANAGER_ID, COURSE_ID }) {
  const courseManager = {
    MANAGER_ID,
    COURSE_ID: COURSE_ID || state.courseForm.COURSE_ID
  }
  try {
    const { data: response } = await api.post('/course/createCourseManager', { courseManager })
    const { success } = response
    if (!success) throw response

    dispatch('fetchManagers', { pagination: state.courseManagerPagination })

    notify.respond(response)
    return response
  } catch (response) {
    notify.respond(response)
    return response
  }
}

async function removeCourseManagers ({ commit, dispatch, state }, managerId) {
  const courseManagers = state.selectedManagers.map(manager => { 
    return { MANAGER_ID: manager.MANAGER_ID, COURSE_ID: state.courseForm.COURSE_ID } 
  })

  try {
    const { data: response } = await api.post('/course/removeCourseManagers', { courseManagers })
    const { success } = response
    if (!success) throw response
    
    dispatch('fetchManagers', { pagination: state.courseManagerPagination })

    notify.respond(response)
    return response
  } catch (response) {
    notify.respond(response)
    return response
  }
}

async function createCourseAffiliate ({ commit, dispatch, state }, { AFFILIATE_ID, COURSE_ID }) {
  const courseAffiliate = {
    AFFILIATE_ID,
    COURSE_ID: COURSE_ID || state.courseForm.COURSE_ID
  }
  
  try {
    const { data: response } = await api.post('/course/createCourseAffiliate', { courseAffiliate })
    const { success } = response
    if (!success) throw response

    dispatch('fetchAffiliates', { pagination: state.courseAffiliatePagination })

    notify.respond(response)
    return response
  } catch (response) {
    notify.respond(response)
    return response
  }
}

async function removeCourseAffiliates ({ commit, dispatch, state }, affiliateId) {
  const courseAffiliates = state.selectedAffiliates.map(affiliate => { 
    return { AFFILIATE_ID: affiliate.AFFILIATE_ID, COURSE_ID: state.courseForm.COURSE_ID } 
  })
  
  try {
    const { data: response } = await api.post('/course/removeCourseAffiliates', { courseAffiliates })
    const { success } = response
    if (!success) throw response

    // courseAffiliatePagination.rowsNumber = response.count
    dispatch('fetchAffiliates', { pagination: state.courseAffiliatePagination })
    
    notify.respond(response)
    return response
  } catch (response) {
    notify.respond(response)
    return response
  }
}
